import React from 'react';
import PathEditor from '../components/PathEditor';

const PathsTab = ({ paths, tools, onUpdate }) => {
    return (
        <div className="space-y-4">
            {paths.map(path => (
                <PathEditor 
                    key={path.path_id} 
                    path={path} 
                    tools={tools}
                    onUpdate={onUpdate}
                />
            ))}
        </div>
    );
};

export default PathsTab;
